<template>
    <ssn-modal></ssn-modal>
    <b-row class="">
      <b-col
          cols="12"
          xl="4"
          lg="5"
          md="5"
        >
          <user-info-card/>
        </b-col>
        <b-col
            cols="12"
            xl="8"
            lg="7"
            md="7"
          >
          <b-row class="match-height">
            <user-plan-view/>
            <reset-and-deactivate/>
          </b-row>
          <user-two-steps-verification :data="user"/>
        </b-col>
    </b-row>
</template>
<script>
import {
  BRow, BCol, BLink,
} from 'bootstrap-vue-3'
import axios from 'axios'
import UserInfoCard from './layout/UserInfoCard.vue'
import UserPlanView from './layout/UserPlanView.vue'
import UserActivityTimeline from './layout/UserActivityTimeline.vue'
import ResetAndDeactivate from './layout/ResetAndDeactivate.vue'
import UserTwoStepsVerification from './layout/UserTwoStepsVerification.vue'

export default {
    name:'BusinessUserAccount',
    components:{
        BRow,
        BCol,
        BLink,
        UserInfoCard,
        UserPlanView,
        UserActivityTimeline,
        ResetAndDeactivate,
        UserTwoStepsVerification
    },
    data(){
      return{
        user:{},
      }
    },
    created() {
        this.getUserData();
    },
    methods: {

      getUserData(){
        let status ={
          status:"0"
        }
        const route = this.$router.resolve(
            {
                name: 'profile'
            }
        );
        axios.post(route.href,status).then(({data})=>{
          this.user=data.data.user
        }).catch();
      },

    },
}
</script>
